import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpParams
} from '@angular/common/http';

import { Observable } from 'rxjs';

import {
  ArticleDetails,
  ArticlesResponse
} from '../models/article';

@Injectable({
  providedIn: 'root'
})
export class ArticleService {

  private readonly apiUrl =
    'https://applicationform.aldawal.com/api/Articles';

  constructor(private http: HttpClient) { }

  getArticles(
    sourceSystemId: number = 1,
    statusId: number = 1,
    page: number = 1,
    pageSize: number = 20,
    id?: string
  ): Observable<ArticlesResponse> {

    let params = new HttpParams()
      .set('sourceSystemId', sourceSystemId.toString())
      .set('statusId', statusId.toString())
      .set('page', page.toString())
      .set('pageSize', pageSize.toString());

    if (id) {
      params = params.set('id', id);
    }

    return this.http.get<ArticlesResponse>(
      this.apiUrl,
      { params }
    );
  }

  getArticleBySlug(
    slug: string
  ): Observable<ArticleDetails> {

    return this.http.get<ArticleDetails>(
      `${this.apiUrl}/by-slug/${encodeURIComponent(slug)}`
    );
  }
}